import { makeVar } from '@apollo/client';
import { createContext } from 'react';

import {
    type AuthorizedMedicationInfoFragment,
    CoverageCardType,
    type CoverageStatus,
    type DigitallyReceivedPrescriberOrderInfoFragment,
    type UnknownMedicationInfoFragment,
} from '../../graphql/generated/graphql';
import type { PrescriptionOffer } from '../../hooks/use-prescription-offers';

export type FillPathway = 'fallback' | 'government' | 'insurance' | 'self-pay';

export type CoverageCardData = {
    bin?: string | null;
    cardHolderId?: string | null;
    coverageCardType: CoverageCardType;
    groupId?: string | null;
    pcn?: string | null;
};

export type UseFillPathwayData = {
    subPathway: string | null;
    originalPathway: FillPathway | null;
    previousPathway: FillPathway | null;
    previousSubPathway: string | null;
    pathway: FillPathway | null;
    setPathway: (options: {
        pathway: FillPathway;
        isUserOverride?: boolean;
    }) => void;
    isPathwayOverridden: boolean;
};

export type FillPrescriptionCtx = {
    // @TODO: when caregiver flows are built into this new set of screens, we need to add undefined back to this type
    medication:
        | AuthorizedMedicationInfoFragment
        | UnknownMedicationInfoFragment;
    // @TODO: when caregiver flows are built into this new set of screens, we need to add UnclaimedPrescriberOrderInfoFragment back to this type
    drx: DigitallyReceivedPrescriberOrderInfoFragment;
    drxId: string;
    coverage: CoverageStatus;
    coverageCard: CoverageCardData | null;
    setCoverageCard: (data: CoverageCardData) => void;
    allOffers: PrescriptionOffer[];
    offers: PrescriptionOffer[];
};

export const FillPrescriptionContext =
    createContext<FillPrescriptionCtx | null>(null);

// Keyed by drxId so coverage cards from different prescriptions don't collide.
// Lives outside React component lifecycle so it survives cross-route navigation.
export const coverageCardVar = makeVar<Record<string, CoverageCardData>>({});

export const justPlacedOnHoldVar = makeVar<boolean | null>(null);
